import { Button, Drawer, DrawerBody, DrawerHeader, DrawerHeaderTitle } from '@fluentui/react-components';
import { Dismiss24Regular } from '@fluentui/react-icons';

export interface PacketLinkBuyProps {
  paylink: string;
  back: () => void;
}

function PacketLinkBuy({paylink, back}: PacketLinkBuyProps) {

  return (
    <Drawer
        type='overlay'
        size='full'
        position='start'
        modalType='alert'
        open={true}
      >
        <DrawerHeader>
          <DrawerHeaderTitle
            action={
              <Button
                appearance="subtle"
                aria-label="Close"
                icon={<Dismiss24Regular />}
                onClick={() => back()}
              />
            }
          >
          </DrawerHeaderTitle>
        </DrawerHeader>

        <DrawerBody>
          <iframe title="payapp" src={paylink} style={{width: '100%', height: '100%', border: 0}} allow='payment' allowTransparency={true}></iframe>
        </DrawerBody>
      </Drawer>
  );
}

export default PacketLinkBuy;
